var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-callback"},[_c('p',[_vm._v("授权处理中，请稍候...")])])
}]

export { render, staticRenderFns }